export const REFRESH_SAMPLE_LIST = 'REFRESH_SAMPLE_LIST';

export const refreshSampleList = samplesData => ({
  type: REFRESH_SAMPLE_LIST,
  samplesData
});



// WEBPACK FOOTER //
// ./src/actions/sampleList.js